import { RosbagBuffer } from './rosbag-buffer';
import { readROS1Bag } from './rosbag-reader-1';
import { readROS2Bag } from './rosbag-reader-2';

export function readROSBag(path: string): {
  buffer: RosbagBuffer;
  isLoaded: Promise<void>;
} {
  let buffer = new RosbagBuffer();

  path = decodeURIComponent(path);
  const sigDec = path.substring(path.indexOf('sig=') + 4);
  const sigEnc = encodeURIComponent(sigDec);
  path = path.replace(sigDec, sigEnc);
  const isMCAP = path.includes('.mcap');
  const isLoaded = isMCAP
    ? readROS2Bag(path, buffer)
    : readROS1Bag(path, buffer);

  return { buffer, isLoaded };
}
